const DOMAIN_COUNTER_MAP = {
    'xn--80aaiffkh1ao6bt1c.xn--p1ai': 109206504, // магазинчудес.рф
};

function getCounterId() {
    const host = window.location.hostname;
    return DOMAIN_COUNTER_MAP[host] || 109206504;
}

export function trackEvent(eventName) {
    if (typeof window.ym === 'function') {
        window.ym(getCounterId(), 'reachGoal', eventName);
    }
}

export function getYandexClientId(timeoutMs = 1500) {
    return new Promise(resolve => {
        if (typeof window.ym !== 'function') {
            resolve(null);
            return;
        }
        let settled = false;
        const done = value => {
            if (settled) return;
            settled = true;
            resolve(value || null);
        };
        try {
            window.ym(getCounterId(), 'getClientID', clientId => done(clientId));
        } catch {
            done(null);
        }
        setTimeout(() => done(null), timeoutMs);
    });
}
